export default "__VITE_ASSET__BLwRd1hG__"